import { BaseService } from './baseService';

class SurveysService extends BaseService<Survey, 'surveyID', 'surveys'> {
	constructor() {
		super('surveyID', 'survey', 'surveys');
	}
}

// This type of exporting is intended to make sure service acts as a singleton.
export default new SurveysService();
